export default __webpack_public_path__ + "static/media/greyDot.41c983ce.svg";